<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter" id="fword"><a href="#/text/toc#c_fword">AUTHOR’S FOREWORD</a></p>
<p class="nonindent1"><samp>I am an idiot.</samp></p>
<p class="indent"><samp>You should know this already, if you’ve read the previous three volumes of my autobiography. If by chance you haven’t read them, then don’t worry. You’ll get the idea. After all, nothing in this book will make any kind of sense to you. You’ll be confused at the difference between the Free Kingdoms and the Hushlands. You’ll wonder why I keep pretending that my glasses are magical. You’ll be baffled by all these insane characters.</samp></p>
<p class="indent"><samp>(Actually, you’ll probably wonder all of those same things if you start from the beginning too. These books don’t really make a lot of sense, you see. Try living through one of them sometime. Then you’ll know what it really means to be confused.)</samp></p>
<p class="indent"><samp>Anyway, as I was saying, if you haven’t read the other three books, then don’t bother. That will make this book even more confusing to you, and that’s exactly what I want. By way of introduction, just let me say this: My name is Alcatraz Smedry, my Talent is breaking things, and I’m stoopid. Really, really stoopid. So stoopid, I don’t know how to spell the word stupid.</samp></p>
<p class="indent"><samp>This is my story. Or, well, part four of it. Otherwise known as “The part where everything goes wrong, and then Alcatraz has a cheese sandwich.”</samp></p>
<p class="indent"><samp>Enjoy.</samp></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fword.vue?491b0bda